"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./QuickLinks.css");
var react_router_dom_1 = require("react-router-dom");
var Link_1 = require("@material-ui/core/Link");
var configs_1 = require("../configs");
var configs_2 = require("../configs");
var Typography_1 = require("@material-ui/core/Typography");
var QuickLinkSplitter = function (props) {
    return (React.createElement("span", { style: { color: "#1976d2", paddingLeft: "15px", paddingRight: "15px", height: "20px", marginBottom: props.smallScreen ? "" : "10px", marginTop: props.smallScreen ? "15px" : "" } }, "|"));
};
exports.default = (function (props) {
    var links = [];
    var smallScreen = window.screen.width < 768;
    for (var i = 0; i < props.pageNames.length; i++) {
        var icon = configs_1.pageIcons[props.pageNames[i]];
        links.push(React.createElement("span", { key: i, style: { display: "inline-flex", alignItems: "center", paddingBottom: smallScreen ? "40px" : "0" } },
            React.createElement(Link_1.default, { component: react_router_dom_1.Link, to: configs_2.componentPaths[props.pageNames[i]], style: { color: "#1976d2", paddingTop: smallScreen ? "20px" : "0" } },
                React.createElement(Typography_1.default, { className: "quickLinkText", variant: "body1", style: { display: "inline-block" } },
                    React.createElement(icon, { style: { marginBottom: "3px" } }, ""),
                    props.linkLabels[i])),
            (i + 1) < props.pageNames.length && React.createElement(QuickLinkSplitter, { smallScreen: smallScreen })));
    }
    return (React.createElement("div", { style: { display: "inline-flex", alignItems: "center", float: "right" } },
        React.createElement(Typography_1.default, { variant: "body1", style: { paddingRight: "15px", paddingTop: smallScreen ? "20px" : "0", paddingBottom: smallScreen ? "40px" : "0" } }, "Quick Links:"),
        " ",
        links));
});
//links.push(
//    <div style={{paddingBottom: "8px"}}>
//        <Link component={RouterLink} to={props.quickLinks[i].pathToComponent} style={{ pointerEvents: "all", color: "#1976d2" }}>{props.quickLinks[i].linkLabel}</Link>
//    </div>
//)
{ /*
<div style={{ float: "right", paddingBottom: "40px", color: "#1976d2", ...props.style}}>
    <TextField
        value=""
        multiline
        variant="outlined"
        color="secondary"
        label="Quick Links"
        style={{
            width: "200px",
            float: "right",
            color: "#1976d2"
        }}
        InputProps={{
            readOnly: true,
            value: "\n",
            style: { paddingTop: "0", paddingBottom: "45px", color: "#1976d2"},
            startAdornment: (
                <InputAdornment style={{ display: "block" }} position="start">
                    {links}
                </InputAdornment>
            )
        }}
    />
    <div style={{height: "20px"}}></div>
</div >
    */
}
//# sourceMappingURL=QuickLinks.js.map